import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY;
export const getServiciosFacturacion = async (params) => {
    try {
        const response = await api.get(`${urlApi}/comercial/getServiciosFacturacion`,{params});
        return response.data;
    } catch (error) {
        console.error("Error al obtener la integración:", error);
        throw error;
    }
};
export const getServiciosFacturacionNoEjecutados = async (params) => {
    try {
        const response = await api.get(`${urlApi}/comercial/getServiciosFacturacionInactivos`,{params});
        return response.data;
    } catch (error) {
        console.error("Error al obtener la integración:", error);
        throw error;
    }
};
export const editarServiciosFacturacion = async (payload,id_usuario) => {
    try {
        const response = await api.put(`${urlApi}/comercial/editServiciosFacturacion`, { json: JSON.stringify(payload), id_usuario });
        return response.data;
    } catch (error) {
        console.error("Error al editar el servicio de facturación:", error);
        throw error;
    }
};